import { GameId, INovaUserAuthHeaders } from '@nova/types';
import axios from 'axios';

/**
 * TODO: (low priority) Change these boost id strings to "EBoostItemId", but only after the endpoint "forge-boost" in the REST server is changed
 * @param authHeaders
 * @param boostId
 * @returns boostId as a string (for now). A simple boolean confirmation would be more appropriate, no?
 */
export async function purchaseBoost(gameAPIEndpoint: string, authHeaders: INovaUserAuthHeaders, boostId?: string): Promise<string> {
  if (!boostId) { return ''; }

  const path = `${GameId.ActionGame}/forge-boost`;
  const response = await axios.patch(`${gameAPIEndpoint}/boosts/${path}/${boostId}`, null, {
    headers: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'Content-Type': 'application/json',
      ...authHeaders
    }
  });

  // Acceptable cast to endpoint response type
  return response.data as string;
}
